import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Row, Col } from "react-bootstrap";

import StyledLink from "../../general/StyledLink";
import SearchBar from "../../general/SearchBar";

const ListaAcupuntura = () => {
  const [data, setData] = useState(null);
  const [dataFilter, setDataFilter] = useState(null);

  const fetchData = async () => {
    const response = await axios.get("/api/Acupuntura");
    setData(response.data);
    setDataFilter(response.data);
  };

  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const filterFunction = (value) => {
    if (value.length > 0) {
      setDataFilter(
        data.filter((item) =>
          item.punto.toLowerCase().includes(`${value}`.toLowerCase())
        )
      );
    } else {
      setDataFilter(data);
    }
  };

  return (
    <Row>
      <Col xs={12}>
        <StyledLink to="/admin">Tablas</StyledLink>
      </Col>
      <Col>
        <h1>Listado puntos Acupuntura</h1>
        <SearchBar title="Buscar Punto" filterFunction={filterFunction} />
        <br />
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Código Acupuntura</th>
              <th>Nombre Punto</th>
              <th>Abreviación</th>
            </tr>
          </thead>
          <tbody>
            {dataFilter
              ? dataFilter.map((item) => {
                  return (
                    <tr key={item.codAcupuntura}>
                      <td>
                        <StyledLink
                          to={`/admin/Acupuntura/${item.codAcupuntura}`}
                        >
                          {item.codAcupuntura}
                        </StyledLink>
                      </td>
                      <td>{item.punto}</td>
                      <td>{item.abreviacion}</td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
      </Col>
    </Row>
  );
};

export default ListaAcupuntura;
